// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".tier-badge[data-v-69473887] {\n  font-style: normal;\n  font-weight: 400;\n  font-size: 10px;\n  background: #e0ecee;\n}\n.tier-badge span[data-v-69473887] {\n  line-height: 20px;\n  color: #0E6488;\n}", ""]);
// Exports
module.exports = exports;
